import React, { Component } from "react";

import Loading from "./components/Loading";
import Titles from "./components/Titles";
import Form from "./components/Form";
import Weather from "./components/Weather";

import "./App.css";

const API_KEY = "af062726e915c12e796aa2f5397ca62e";

class App extends Component {
    state = {
        temperature: undefined,
        city: undefined,
        country: undefined,
        humidity: undefined,
        description: undefined,
        lat: undefined,
        lon: undefined,
        error: undefined,
        loading: true,
        icon: undefined
    };

    showError = errmsg => {
        this.setState({
            temperature: undefined,
            city: undefined,
            country: undefined,
            humidity: undefined,
            description: undefined,
            lat: undefined,
            lon: undefined,
            error: errmsg,
            loading: false,
            icon: undefined
        });
    };

    // use this func to handle when the button has been clicked.
    handleSubmit = e => {
        e.preventDefault();
        this.getWeather(e);
    };

    getBrowserLatLon = async pos => {
        this.setState({
            lat: pos.coords.latitude.toString(),
            lon: pos.coords.longitude.toString()
        });

        const lat = this.state.lat;
        const lon = this.state.lon;

        if (this.state.city === undefined && this.state.country === undefined) {
            try {
                const api_call = await fetch(
                    `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=metric`
                );
                const data = await api_call.json();

                // show's browser data
                console.info(
                    `lat: ${lat}, lon: ${lon}, returned data:${JSON.stringify(
                        data
                    )}`
                );

                if (data.cod !== "404") {
                    this.setState({
                        temperature: data.main.temp,
                        city: data.name,
                        country: data.sys.country,
                        humidity: data.main.humidity,
                        description: data.weather[0].description,
                        lat: lat,
                        lon: lon,
                        error: undefined,
                        loading: false,
                        icon: data.weather[0].icon + ".png"
                    });
                } else {
                    this.showError(
                        data.message +
                            ", please check your spelling, and try again"
                    );
                }
            } catch (err) {
                this.showError(err);
            }
        }
    };

    // from the weather component
    getWeather = async e => {
        const city = e.target.elements.city.value;
        const country = e.target.elements.country.value;

        if (city && country) {
            try {
                const api_call = await fetch(
                    `https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&appid=${API_KEY}&units=metric`
                );
                const data = await api_call.json();
                // show's data when location is provided
                console.info(
                    `city: ${city}, country: ${country}, returned data:${JSON.stringify(
                        data
                    )}`
                );

                if (data.cod !== "404") {
                    this.setState({
                        temperature: data.main.temp,
                        city: data.name,
                        country: data.sys.country,
                        humidity: data.main.humidity,
                        description: data.weather[0].description,
                        error: undefined,
                        loading: false,
                        icon: data.weather[0].icon + ".png"
                    });
                    // get the icon of the weather
                } else {
                    this.showError(
                        data.message +
                            ", please check your spelling, and try again"
                    );
                }
            } catch (err) {
                this.showError(err);
            }
        } else {
            this.showError("Please enter values");
        }
    };

    componentDidMount = () => {
        var that = this;
        // check to see if we're allowed to get the users browsers location
        navigator.geolocation.watchPosition(
            function(position) {
                navigator.geolocation.getCurrentPosition(position => {
                    that.getBrowserLatLon(position);
                });
            },
            function(error) {
                if (error.code === error.PERMISSION_DENIED) {
                    that.setState({
                        loading: false
                    });
                }
            }
        );
    };

    render() {
        return (
            <div>
                <div className="wrapper">
                    <div className="main">
                        <div className="container">
                            <div className="row">
                                <div className="col-xs-12 col-sm-5 title-container">
                                    <Titles />
                                </div>

                                <div className="col-xs-12 col-sm-7 form-container">
                                    {this.state.loading ? (
                                        <Loading />
                                    ) : (
                                        <React.Fragment>
                                            <Form
                                                handleSubmit={this.handleSubmit}
                                            />
                                            <Weather
                                                temperature={
                                                    this.state.temperature
                                                }
                                                city={this.state.city}
                                                country={this.state.country}
                                                humidity={this.state.humidity}
                                                description={
                                                    this.state.description
                                                }
                                                error={this.state.error}
                                                icon={this.state.icon}
                                            />
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
